export function supportsHEVCAlpha() {
  const navigator = window.navigator;
  const ua = navigator.userAgent.toLowerCase();
  const hasMediaCapabilities = !!(
    navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo
  );
  const isSafari =
    ua.indexOf('safari') != -1 && !(ua.indexOf('chrome') != -1) && ua.indexOf('version/') != -1;
  const isChromeIOS = /CriOS/i.test(ua) && /iphone|ipod|ipad/i.test(ua);

  return (isSafari || isChromeIOS) && hasMediaCapabilities;
}

export function isSafari() {
  if (typeof window === 'undefined') {
    return;
  }
  const navigator = window.navigator;
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.indexOf('safari') != -1 && !(ua.indexOf('chrome') != -1) && ua.indexOf('version/') != -1
  );
}

export function isIos() {
  if (typeof window === 'undefined') {
    return;
  }
  const navigator = window.navigator;
  return /iPad|iPhone/.test(navigator.userAgent);
}
